import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {getAiAgentServiceURL} from 'src/utils/helper';
import {
    AiAgentChatRequest,
    AiAgentChatResponse,
    AiAgentMessagesResponse,
    AiAgentSessionCountResponse,
    AiAgentSessionInitRequest,
    AiAgentSessionInitResponse,
    AiAgentSessionResponse,
    AiAgentSessionsResponse,
    AiAgentUsage,
} from 'src/types';

export const aiAgentApi = createApi({
    reducerPath: 'aiAgentApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({baseUrl: String(getAiAgentServiceURL())}),
    endpoints: (build) => ({
        initSession: build.mutation<AiAgentSessionInitResponse, AiAgentSessionInitRequest>({
            query: (data) => ({url: '/sessions/init', method: 'post', data}),
        }),
        sendMessage: build.mutation<AiAgentChatResponse, AiAgentChatRequest>({
            query: (data) => ({url: '/chat', method: 'post', data}),
        }),
        getSession: build.query<AiAgentSessionResponse, string>({
            query: (sessionId) => ({url: `/sessions/${sessionId}`, method: 'get'}),
        }),
        getMessages: build.query<AiAgentMessagesResponse, string>({
            query: (sessionId) => ({url: `/sessions/${sessionId}/messages`, method: 'get'}),
        }),
        getSessions: build.query<AiAgentSessionsResponse, {userId: number; limit?: number}>({
            query: ({userId, limit = 20}) => ({url: `/users/${userId}/sessions?limit=${limit}`, method: 'get'}),
        }),
        getSessionCount: build.query<AiAgentSessionCountResponse, number>({
            query: (userId) => ({url: `/users/${userId}/sessions/count`, method: 'get'}),
        }),
        getUsage: build.query<AiAgentUsage, number>({
            query: (userId) => ({url: `/users/${userId}/usage`, method: 'get'}),
        }),
        closeSession: build.mutation<{status: string}, string>({
            query: (sessionId) => ({url: `/sessions/${sessionId}`, method: 'delete'}),
        }),
        getHealth: build.query<{status: string; provider: string}, void>({
            query: () => ({url: '/health', method: 'get'}),
        }),
    }),
});